// Modern Background Gradients
export const modernGradients = [
  'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)', // Cosmic Purple
  'linear-gradient(135deg, #4facfe 0%, #00f2fe 50%, #43e97b 100%)', // Ocean Breeze
  'linear-gradient(135deg, #fa709a 0%, #fee140 50%, #30cfd0 100%)', // Sunset Paradise
  'linear-gradient(135deg, #a8edea 0%, #fed6e3 50%, #667eea 100%)', // Cotton Candy
  'linear-gradient(135deg, #ff6a00 0%, #ee0979 50%, #6f42c1 100%)', // Fire & Ice
  'linear-gradient(135deg, #f093fb 0%, #f5576c 50%, #4facfe 100%)', // Pink Flamingo
  'linear-gradient(135deg, #30cfd0 0%, #330867 50%, #c471ed 100%)', // Deep Ocean
  'linear-gradient(135deg, #43e97b 0%, #38f9d7 50%, #667eea 100%)', // Mint Galaxy
  'linear-gradient(135deg, #ffecd2 0%, #fcb69f 50%, #ff6a88 100%)', // Peach Blossom
  'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 50%, #fbc2eb 100%)', // Sky Dream
  'linear-gradient(135deg, #fccb90 0%, #d57eeb 50%, #667eea 100%)', // Golden Hour
  'linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 50%, #43e97b 100%)', // Lavender Mint
  'linear-gradient(135deg, #f77062 0%, #fe5196 50%, #c471f5 100%)', // Coral Passion
  'linear-gradient(135deg, #fa8bff 0%, #2bd2ff 50%, #2bff88 100%)', // Neon Dreams
  'linear-gradient(135deg, #fddb92 0%, #d1fdff 50%, #a8edea 100%)', // Tropical Breeze
  'linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #ffecd2 100%)', // Rose Garden
  'linear-gradient(135deg, #667eea 0%, #f77062 50%, #fee140 100%)', // Electric Sunset
  'linear-gradient(135deg, #2af598 0%, #009efd 50%, #d4fc79 100%)', // Aurora
  'linear-gradient(135deg, #cd9cf2 0%, #f6f3ff 50%, #a8edea 100%)', // Soft Violet
  'linear-gradient(135deg, #ff6b6b 0%, #feca57 50%, #48dbfb 100%)'  // Summer Vibes
];

// Function to get random gradient
export const getRandomGradient = () => {
  const randomIndex = Math.floor(Math.random() * modernGradients.length);
  return modernGradients[randomIndex];
};